'use client'

import { createContext } from 'react'

export const ClockTimestampContext = createContext(0)
